export default {
  withBackbox: {
    id: 'listings_with_buybox',
    defaultMessage: 'With Backbox',
  },
  withoutBackbox: {
    id: 'listings_without_buybox',
    defaultMessage: 'Without Backbox',
  },
  offline: {
    id: 'listings_offline',
    defaultMessage: 'Offline',
  },
  market: {
    id: 'listings_market_header',
    defaultMessage: 'Market',
  },
  grades: {
    id: 'listings_market_condition',
    defaultMessage: 'Condition',
  },
  backboxPrice: {
    id: 'listings_buybox_price',
    defaultMessage: 'Buybox price',
  },
  backboxPriceTooltip: {
    id: 'bo_seller.listings.listings_table.backbox_price_column_tooltip_dynamic_pricing_up',
    defaultMessage:
      "This is the current BackBox price for your listing in each market. The price shown doesn't include the adjustment fee, if applicable. ",
  },
  currentBMPrice: {
    id: 'listings_current_bm_price',
    defaultMessage: 'Current BM price',
  },
  price: {
    id: 'listings_my_price',
    defaultMessage: 'My price',
  },
  pricingStrategy: {
    id: 'bo_seller.listings.pricing_strategy',
    defaultMessage: 'Pricing strategy',
  },
  alerts: {
    id: 'listings_alerts',
    defaultMessage: 'Alerts',
  },
  backboxIsBeingUpdated: {
    id: 'listings_warning_buybox_is_being_updated',
    defaultMessage: 'Buybox is being updated',
  },
  save: {
    id: 'listings_save',
    defaultMessage: 'Save',
  },
  getBackbox: {
    id: 'listings_get_backbox',
    defaultMessage: 'Get Backbox',
  },
  getAllBackboxes: {
    id: 'listings_get_all_buybox',
    defaultMessage: 'Get all Buybox',
  },
  priceLabel: {
    id: 'listings_price_label_new',
    defaultMessage: 'Price ({currency})',
  },
  minimumPriceLabel: {
    id: 'listings_minimum_price_label_new',
    defaultMessage: 'Minimum price ({currency})',
  },
  targetPriceLabel: {
    id: 'listings_target_price_label_new',
    defaultMessage: 'Target price ({currency})',
  },
  gradesInfo: {
    id: 'listings_modal_new_grades_info',
    defaultMessage: 'Information',
  },
  title: {
    id: 'listings_modal_new_grades_title',
    defaultMessage: 'Listings Condition',
  },
  paragraph: {
    id: 'listings_modal_new_grades_paragraph',
    defaultMessage:
      'The condition is a combination of the aesthetic condition you declared and the expected defective rate BackMarket is evaluating for this listing.',
  },
  bulletPoint1: {
    id: 'listings_modal_new_grades_bullet_point_1',
    defaultMessage:
      'If we predict a low defective rate the condition will only be determined by the aesthetic condition.',
  },
  bulletPoint2: {
    id: 'listings_modal_new_grades_bullet_point_2',
    defaultMessage:
      'If we predict an average defective rate the condition will either be Very Good (for a Good, Very Good or Mint aesthetic condition) or Eco (for a Stallone or Fair aesthetic condition).',
  },
  bulletPoint3: {
    id: 'listings_modal_new_grades_bullet_point_3',
    defaultMessage:
      'If we predict a high defective rate the condition will be Eco no matter the aesthetic condition.',
  },
  cta: {
    id: 'listings_modal_new_grades_learn_more',
    defaultMessage: 'More information available {link, html}.',
  },
  here: {
    id: 'listings_modal_new_grades_learn_more_here',
    defaultMessage: 'here',
  },
  minimumPrice: {
    id: 'listings_minimum_price',
    defaultMessage: 'Minimum Price',
  },
  minimumPriceSetBeforeTargetPriceError: {
    id: 'listings_minimum_price_set_before_target_price_error',
    defaultMessage: 'The target price must be set before the minimum price',
  },
  minimumPriceBelowTargetPriceError: {
    id: 'listings_minimum_price_error',
    defaultMessage: 'The minimum price must be below the target price',
  },
  minimumPriceIsToLow: {
    id: 'listings_minimum_price_is_to_low_new',
    defaultMessage:
      'The minimum price must be above { limit }% of the target price. Enter at least { limit }% of the target price to activate BackPricer',
  },
  targetPrice: {
    id: 'listings_target_price',
    defaultMessage: 'Target Price',
  },
  targetPriceError: {
    id: 'listings_target_price_error',
    defaultMessage: 'The target price must be higher than the target price',
  },
  targetPriceIsTooHigh: {
    id: 'bo-seller.listings.target_price_is_too_high',
    defaultMessage:
      "Your target price can't be more than {limit}% higher than the minimum price",
  },
  backPricer: {
    id: 'listings_backpricer_label',
    defaultMessage: 'BackPricer',
  },
  hasBackbox: {
    id: 'listings_warning_you_have_the_buybox',
    defaultMessage: 'You have the Buybox',
  },
  warningOffline: {
    id: 'listings_warning_offline',
    defaultMessage: 'Listing offline. {cta, html}.',
  },
  warningOfflineCta: {
    id: 'listings_warning_offline_cta',
    defaultMessage: 'See the issue',
  },
  belowBackboxPrice: {
    id: 'listings_warning_buybox_price',
    defaultMessage: 'You need to be below {price}',
  },
  hasBackboxWithOtherListing: {
    id: 'listings_warning_buybox_has_same_merchant_winner',
    defaultMessage:
      'This listing doesn’t have the Backbox. But another one of your listings has it',
  },
  pricingStrategyTitle: {
    id: 'bo_seller.listings.pricing_strategy_title',
    defaultMessage: 'Maximize your sales.',
  },
  pricingStrategyDescription: {
    id: 'bo_seller.listings.pricing_strategy_description_new',
    defaultMessage:
      'Update price to {price} to sell {demand} more units over the next 7 days.',
  },
  pricingStrategyUpdate: {
    id: 'bo_seller.listings.pricing_strategy_update_button',
    defaultMessage: 'Update',
  },
}
